<template>
  <div>
    <el-table
      :data="content"
      :row-class-name="tableRowClassName">
      <el-table-column
        label="排序"
        width="80">
        <template scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="展示方式"
        width="100">
        <template scope="scope">
          <span>{{ scope.row.show_type | contentShowType }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="包含功能组合">
        <template scope="scope">
          <span>{{ getContent(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="250">
        <template scope="scope">
          <div class="p-t-10 p-b-10">
            <span>
              <el-button size="small" type="primary" @click="setCurContent(scope.row, scope.$index)">配置</el-button>
            </span>
            <span>
              <el-button size="small" @click="sortUp(scope.$index)" :disabled="scope.$index == 0">上移</el-button>
            </span>
            <span>
              <el-button size="small" @click="sortDown(scope.$index)" :disabled="scope.$index == content.length - 1">下移</el-button>
            </span>
            <span>
              <el-button size="small" @click="deleteContent(scope.$index)">删除</el-button>
            </span>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<style>
  .el-table .info-row {
    background: #c9e5f5;
  }
</style>

<script>
  export default {
    props: {
      content: {
        type: Array,
        default() {
          return []
        }
      },
      contentsById: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    data() {
      return {
        curIndex: ''
      }
    },
    methods: {
      tableRowClassName(row, index) {
        if (index === this.curIndex) {
          return 'info-row'
        }
        return ''
      },
      getContent(item) {
        let string = ''
        _(item.arr).forEach((res) => {
          if (res.content_id) {
            string += this.contentsById[res.content_id]
            string += ','
          }
        })
        string = string.substr(0, string.length - 1)
        return string
      },
      resetIndex() {
        this.curIndex = ''
      },
      deleteContent(index) {
        this.resetIndex()
        this.$emit('deleteContent', index)
      },
      setCurContent(item, index) {
        this.$emit('setCurContent', item)
        this.curIndex = index
      },
      sortUp(index) {
        let temp = this.content[index]
        this.content.splice(index, 1)
        this.content.splice(index - 1, 0, temp)
      },
      sortDown(index) {
        let temp = this.content[index]
        this.content.splice(index, 1)
        this.content.splice(index + 1, 0, temp)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// contentTable.vue?bc83c76c